export const LAYER_GRASS = 0
export const LAYER_ROAD = 1
export const LAYER_OBJECTS = 2
export const LAYER_PARTICLES = 3
export const LAYER_CARS = 4
export const LAYER_PLAYER = 500
export const LAYER_EMOTE = 6
export const LAYER_HUD = 1000
